/* eslint-disable func-style */
// 报表
const ReportAssembly = () => import('@/pages/ReportForms/ReportAssembly.vue');
const JXSWTrainingLevel = () => import('@/pages/ReportForms/JXSWTrainingLevel.vue');// 01514_008
const ClassArrears2 = () => import('@/pages/ReportForms/ClassArrears2.vue');// 99999_006
const ClassCollection2 = () => import('@/pages/ReportForms/ClassCollection2.vue');// 99999_007


const ReportRouter = [
	{ path: '/ReportAssembly', name: 'ReportAssembly', component: ReportAssembly },
	{ path: '/JXSWTrainingLevel', name: 'JXSWTrainingLevel', component: JXSWTrainingLevel },
	{ path: '/ClassArrears2', name: 'ClassArrears2', component: ClassArrears2 },
	{ path: '/ClassCollection2', name: 'ClassCollection2', component: ClassCollection2 },

];

export default ReportRouter;
